/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { auditlogsList } from "../funcs/auditlogsList.js";
import { auditlogsListFacets } from "../funcs/auditlogsListFacets.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListAuditLogFacetsResult } from "../models/components/listauditlogfacetsresult.js";
import {
  ListAuditLogFacetsRequest,
  ListAuditLogFacetsSecurity,
} from "../models/operations/listauditlogfacets.js";
import {
  ListAuditLogsRequest,
  ListAuditLogsResponse,
  ListAuditLogsSecurity,
} from "../models/operations/listauditlogs.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class Auditlogs extends ClientSDK {
  /**
   * list auditlogs
   *
   * @remarks
   * List audit logs across organization and projects.
   */
  async list(
    request?: ListAuditLogsRequest | undefined,
    security?: ListAuditLogsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<PageIterator<ListAuditLogsResponse, { cursor: string }>> {
    return unwrapResultIterator(auditlogsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listFacets auditlogs
   *
   * @remarks
   * List available audit log facet values across organization and projects.
   */
  async listFacets(
    request?: ListAuditLogFacetsRequest | undefined,
    security?: ListAuditLogFacetsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListAuditLogFacetsResult> {
    return unwrapAsync(auditlogsListFacets(
      this,
      request,
      security,
      options,
    ));
  }
}
